<template>
  <v-dialog v-model="dialogOpened">
    <v-widget
      :title="$t(title)"
      class="mb-4"
    >
      <div slot="widget-header-action">
        <v-btn
          :loading="!collectionInitialized"
          class="primary text-capitalize"
          @click="saveRelation"
        >
          {{ $t('Add Selected') }}
        </v-btn>
      </div>

      <div slot="widget-content">
        <v-flex>
          <v-data-table
            :items="collection"
            :headers="collectionHeaders"
            :loading="!collectionInitialized"
            :total-items="pagination.totalItems"
            :rows-per-page-text="$t('Rows per page')"
            @update:pagination="initialize"
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            />
            <template v-slot:items="{ item }">
              <tr @click="toggleSelected(item)">
                <td class="text-xs-left">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    :disabled="isOriginallySelected(item)"
                    hide-details
                  />
                </td>
                <td
                  v-for="(field, index) in fields"
                  :key="index"
                >
                  <span v-if="['integer', 'string'].includes(field.format)">{{ item[field.name] }}</span>
                  <span v-if="field.format === 'money'">{{ item[field.name] | money }}</span>
                </td>
              </tr>
            </template>
            <template v-slot:pageText="props">
              <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
            </template>
          </v-data-table>
        </v-flex>
      </div>
    </v-widget>
  </v-dialog>
</template>

<script>
import $c from '@/services/api/lib/container'

export default {
  name: 'AddRelationDialog',

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    modelGetRequestConfig: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      collection: [],
      newlySelected: [],
      collectionHeaders: [{ sortable: false }],
      collectionInitialized: false,
      page: {
        current_page: 0,
        last_page: 0,
        per_page: 25,
        total: 0
      },
      sort: {
        field: '',
        descending: false
      }
    }
  },

  computed: {
    pagination: {
      get () {
        return {
          descending: this.sort.descending,
          page: this.page.current_page,
          rowsPerPage: this.page.per_page,
          sortBy: this.sort.field,
          totalItems: this.page.total
        }
      },
      set (value) {
        this.sort.descending = value.descending
        this.sort.field = value.sortBy
      }
    },

    dialogOpened: {
      get () {
        return this.dialog
      },
      set (value) {
        this.$emit('dialog-closed')
      }
    }
  },

  created () {
    this.collectionHeaders = this.collectionHeaders.concat(this.headers)
  },

  methods: {
    saveRelation () {
      this.$emit('relation-items-added', this.newlySelected)
    },

    async initialize (data = this.pagination) {
      let _sortBy = data.descending ? '-' : ''
      _sortBy += data.sortBy

      const collectionData = await $c.get(this.model)
        .page(data.page || 1)
        .limit(data.rowsPerPage || 25)
        .orderBy(_sortBy)
        .getFullData(this.modelGetRequestConfig)

      this.collection = collectionData.collection
      this.page = collectionData.page

      this.collectionInitialized = true
    },

    isSelected (item) {
      return this.selected.concat(this.newlySelected).some(e => e.id === item.id)
    },

    isOriginallySelected (item) {
      return this.selected.some(e => e.id === item.id)
    },

    toggleSelected (item) {
      if (this.isSelected(item)) {
        this.newlySelected = this.newlySelected.filter(e => e.id !== item.id)
      } else {
        this.newlySelected.push(item)
      }
    }
  }
}
</script>
